export default __webpack_public_path__ + "static/media/ic_sint_maarten.07d9320b.svg";